<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Swal from "sweetalert2";

import { todoComputed, todoMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
/**
 * Starter component
 */
export default {
  page: {
    title: "Form Driver",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      selected: {
        licence_type: [],
        job_experience: [],
      },
      selectedModel: {
        licence_type: [],
        job_experience: [],
      },
      allSelected: {
        licence_type: false,
        job_experience: false,
      },
      indeterminate: {
        licence_type: true,
        job_experience: true,
      },
      tData: {
        fleet_history: [],
        licence_type: [],
        job_experience: [],
        violation_history: [],
      },

      form: {
        name: null,
        address: null,
        place_birth: null,
        date_birth: null,
        phone_no: null,
        joined_date: null,
        place_requirement: null,
        nik_no: null,
        ktp_no: null,
        marial_status: null,
        bank_account_no: null,
        bpjs_kes_no: null,
        bpjs_kes_jht: null,
        jaminan: null,
        family_phone_first: null,
        family_phone_second: null,
        reference: null,
        fleet_category: null,
        current_fleet: null,
        current_position: null,
        status: null,
      },

      loading: false,
    };
  },
  validations: {
    form: {
      name: { required },
      place_requirement: { required },
      ktp_no: { required },
      fleet_category: { required },
    },
  },
  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */

    title() {
      return this.$t("global.driver") + " Form";
    },

    items() {
      return [
        {
          text: this.$t("menuitems.masterData.text"),
        },
        {
          text: this.$t("global.driver"),
        },
        {
          text: "Form",
          active: true,
        },
      ];
    },

    fleet_history() {
      return [
          {
            key: "date_time",
            label: this.$t("master.form.driver.fleetHis.dateTime"),
          },
          {
            key: "information",
            label: this.$t("master.form.driver.fleetHis.information"),
          },
          {
            key: "plate_no",
            label: this.$t("master.form.driver.fleetHis.platNumber"),
          },
          {
            key: "fleet_type",
            label: this.$t("master.form.driver.fleetHis.fleetType"),
          },
          {
            key: "driver_type",
            label: this.$t("master.form.driver.fleetHis.driverType"),
          },
      ]
    },

    licence_type()
    {
      return[
      {
        key: "check",
      },
      {
        key: "type",
        label: this.$t("master.form.fleet.documentPermit.type"),
        tdClass: "typeWidth",
      },
      {
        key: "number",
        label: this.$t("master.form.fleet.documentPermit.number")
      },
      {
        key: "expired",
        label: this.$t("master.form.fleet.documentPermit.expired"),
      },
      {
        key: "status",
        label: this.$t("master.form.fleet.documentPermit.status.text"),
      },
      ]
    },

    job_experience() {
      return [
        {
          key: "check",
        },
        {
          key: "job_experience",
          label: this.$t("master.form.driver.jobExp.text"),
        },
      ]
    },

    violation_history () {
      return[
          {
            key: "date",
            label: this.$t("master.form.driver.violationHis.date"),
          },
          {
            key: "source",
            label: this.$t("master.form.driver.violationHis.source"),
          },
          {
            key: "type",
            label: this.$t("master.form.driver.violationHis.type"),
          },
          {
            key: "score",
            label: this.$t("master.form.driver.violationHis.score"),
          }
      ]
    }
  },
  created() {
    for (let i = 0; i < this.tData.licence_type.length; i++) {
      this.selectedModel.licence_type.push(false);
    }
    for (let i = 0; i < this.tData.job_experience.length; i++) {
      this.selectedModel.job_experience.push(false);
    }

    this.$watch("selected.licence_type", (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.licence_type = false;
        this.allSelected.licence_type = false;
      } else if (newValue.length == this.tData.licence_type.length) {
        this.indeterminate.licence_type = false;
        this.allSelected.licence_type = true;
      } else {
        this.indeterminate.licence_type = true;
        this.allSelected.licence_type = false;
      }
    });

    this.$watch("selected.job_experience", (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.job_experience = false;
        this.allSelected.job_experience = false;
      } else if (newValue.length == this.tData.licence_type.length) {
        this.indeterminate.job_experience = false;
        this.allSelected.job_experience = true;
      } else {
        this.indeterminate.job_experience = true;
        this.allSelected.job_experience = false;
      }
    });
  },
  methods: {
    ...todoMethods,
    submitForm() {
      // stop here if form is invalid
      this.$v.$touch();
    },
    toggleAll(checked, param) {
      this.selectedModel[param] = [];
      this.selected[param] = [];
      if (checked) {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selected[param].push(i);
          this.selectedModel[param].push(true);
        }
      } else {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selectedModel[param].push(false);
        }
        this.selected[param] = [];
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index);
      } else {
        var myIndex = this.selected[param].indexOf(data.index);
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1);
        }
      }
    },
    add(param, obj) {
      this.tData[param].push(obj);
    },
    checkStatus(index) {
      const today = new Date();
      const zeroPad = (num, places) => String(num).padStart(places, "0");
      const date =
        today.getFullYear() +
        "-" +
        zeroPad(today.getMonth() + 1, 2) +
        "-" +
        today.getDate();
      if (date >= this.tData.licence_type[index].expired) {
        this.tData.licence_type[index].status = "expired";
      } else {
        var range = this.getDatesInRange(
          date,
          this.tData.licence_type[index].expired
        ).length;
        if (range <= 30) {
          this.tData.licence_type[index].status = "near";
        } else {
          this.tData.licence_type[index].status = "active";
        }
      }
    },
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      const date = new Date(startDate.getTime());

      const dates = [];

      while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      return dates;
    },
    toDelete(param) {
      this.selected[param].sort();
      this.selected[param].reverse();
      this.selected[param].forEach((row) => {
        this.$delete(this.tData[param], row);
      });
      this.selected[param] = [];
      this.selectedModel[param] = [];

      this.indeterminate[param] = false;
      this.allSelected[param] = false;
      for (let i = 0; i < this.tData[param].length; i++) {
        this.selectedModel[param].push(false);
      }
    },
    toCancel() {
      Swal.fire({
        title: "Batalkan",
        text: "Anda yakin akan membatalkan",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.$router.push("/master/driver");
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <form class="needs-validation mc-form" @submit.prevent="submitForm">
      <b-row>
        <b-col xl="12" md="12">
          <div class="float-end mb-3">
            <b-button variant="primary" type="submit" class="mx-2" size="sm">
              <i class="bx bxs-save"></i> {{ this.$t("global.save") }}
            </b-button>
            <b-button variant="secondary" @click="toCancel" size="sm">
              <i class="fas fa-times"></i> {{ this.$t("global.cancel") }}
            </b-button>
          </div>
        </b-col>
        <b-col xl="6" md="6">
          <b-card :title="this.$t('master.form.driver.detailInfo.text')">
            <b-row>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="name_label"
                    :label="this.$t('master.form.driver.detailInfo.name')"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      :placeholder="
                        $t('global.form.enter') + ' ' + $t('master.form.driver.detailInfo.name')
                      "
                      v-model="form.name"
                      trim
                      :class="{
                        'is-invalid': $v.form.name.$error,
                      }"
                    ></b-form-input>
                    <div v-if="$v.form.name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.name.required">
                        {{ $t("master.form.driver.detailInfo.name") }}
                        {{ $t("global.validation.required") }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="8" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="fleetbrand_label"
                    :label="$t('master.form.fleet.fleetBrandType')"
                    label-for="fleetbrand"
                  >
                    <b-form-input
                      id="fleetbrand"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.fleet.fleetBrandType')"
                      v-model="form.address"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="place_birth_label"
                    :label="this.$t('master.form.driver.detailInfo.placeBirth')"
                    label-for="place_birth"
                  >
                    <b-form-input
                      id="place_birth"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.detailInfo.placeBirth')"
                      v-model="form.place_birth"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="date_birth_label"
                    :label="this.$t('master.form.driver.detailInfo.dateBirth')"
                    label-for="date_birth"
                  >
                    <date-picker
                      id="date_birth"
                      v-model="form.date_birth"
                      lang="id"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.detailInfo.dateBirth')"
                    ></date-picker>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="phone_no_label"
                    :label="this.$t('master.form.driver.detailInfo.phone')"
                    label-for="phone_no"
                  >
                    <b-form-input
                      id="phone_no"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.detailInfo.phone')"
                      v-model="form.phone_no"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <h5 class="card-title mt-3">{{$t("master.form.driver.additional.text")}}</h5>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="joined_birth_label"
                    :label="this.$t('master.form.driver.additional.joinedDate')"
                    label-for="joined_birth"
                  >
                    <date-picker
                      id="joined_birth"
                      v-model="form.joined_birth"
                      lang="id"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.joinedDate')"
                    ></date-picker>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="place_requirement_label"
                    :label="this.$t('master.form.driver.additional.placeOfRecruitment')"
                    label-for="place_requirement"
                  >
                    <v-select
                      v-model="form.place_requirement"
                      :placeholder="this.$t('master.form.driver.additional.placeOfRecruitment')"
                      :options="['Canada', 'United States']"
                      :class="{
                        'is-invalid': $v.form.place_requirement.$error,
                      }"
                    ></v-select>
                    <div
                      v-if="$v.form.place_requirement.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.place_requirement.required">
                        {{ $t("master.form.driver.additional.placeOfRecruitment") }}
                        {{ $t("global.validation.required") }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="nik_no_label"
                    :label="this.$t('master.form.driver.additional.nik')"
                    label-for="nik_no"
                  >
                    <b-form-input
                      id="nik_no"
                      :placeholder="$t('global.form.enter') + ' ' + this.$t('master.form.driver.additional.nik')"
                      v-model="form.nik_no"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="ktp_no_label"
                    :label="this.$t('master.form.driver.additional.ktp')"
                    label-for="ktp_no"
                  >
                    <b-form-input
                      id="ktp_no"
                      :placeholder="$t('global.form.enter') + ' ' + this.$t('master.form.driver.additional.nik')"
                      v-model="form.ktp_no"
                      type="number"
                      trim
                      :class="{
                        'is-invalid': $v.form.place_requirement.$error,
                      }"
                    ></b-form-input>
                    <div
                      v-if="$v.form.place_requirement.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.place_requirement.required">
                        {{ $t("master.form.driver.additional.ktp") }}
                        {{ $t("global.validation.required") }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="marial_status_label"
                    :label="this.$t('master.form.driver.additional.marial')"
                    label-for="marial_status"
                  >
                    <v-select
                      v-model="form.marial_status"
                      :placeholder="this.$t('master.form.driver.additional.marial')"
                      :options="['Menikah', 'Lajang', 'Duda / Janda']"
                    ></v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="bank_account_no_label"
                    :label="this.$t('master.form.driver.additional.bankAccount')"
                    label-for="bank_account_no"
                  >
                    <b-form-input
                      id="bank_account_no"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.bankAccount')"
                      v-model="form.bank_account_no"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="bpjs_kes_no_label"
                    :label="this.$t('master.form.driver.additional.bpjskes')"
                    label-for="bpjs_kes_no"
                  >
                    <b-form-input
                      id="bpjs_kes_no"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.bpjskes')"
                      v-model="form.bpjs_kes_no"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="bpjs_jht_no_label"
                    :label="this.$t('master.form.driver.additional.bpjsjht')"
                    label-for="bpjs_jht_no"
                  >
                    <b-form-input
                      id="bpjs_jht_no"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.bpjsjht')"
                      v-model="form.bpjs_jht_no"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="jaminan_label"
                    :label="this.$t('master.form.driver.additional.bpjsjam')"
                    label-for="jaminan"
                  >
                    <b-form-input
                      id="jaminan"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.bpjsjam')"
                      v-model="form.jaminan"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="family_phone_first_label"
                    :label="this.$t('master.form.driver.additional.familyOne')"
                    label-for="family_phone_first"
                  >
                    <b-form-input
                      id="family_phone_first"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.familyOne')"
                      v-model="form.family_phone_first"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="family_phone_second_label"
                    :label="this.$t('master.form.driver.additional.familyTwo')"
                    label-for="family_phone_second"
                  >
                    <b-form-input
                      id="family_phone_second"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.familyTwo')"
                      v-model="form.family_phone_second"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="reference_label"
                    :label="this.$t('master.form.driver.additional.reference')"
                    label-for="reference"
                  >
                    <b-form-input
                      id="reference"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.additional.reference')"
                      v-model="form.reference"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-card>
          <b-card :title="this.$t('master.form.driver.fleetHis.text')">
            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :fields="fleet_history"
              :items="tData.fleet_history"
              class="mt-3"
            >
            </b-table>
          </b-card>
        </b-col>
        <b-col xl="6" md="6">
          <b-card :title="this.$t('master.form.driver.driverStatus.text')">
            <b-row>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="fleet_category_label"
                    :label="this.$t('master.form.fleet.fleetCategory')"
                    label-for="fleet_category"
                  >
                    <v-select
                      v-model="form.fleet_category"
                      :placeholder="$t('master.form.fleet.fleetCategory')"
                      :options="['Canada', 'United States']"
                      :class="{
                        'is-invalid': $v.form.fleet_category.$error,
                      }"
                    ></v-select>
                    <div
                      v-if="$v.form.fleet_category.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.fleet_category.required">
                        {{ $t("master.form.fleet.fleetCategory") }}
                        {{ $t("global.validation.required") }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="current_fleet_label"
                    :label="this.$t('master.form.driver.driverStatus.currentFleet')"
                    label-for="current_fleet"
                  >
                    <b-form-input
                      id="current_fleet"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.driverStatus.currentFleet')"
                      v-model="form.current_fleet"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="current_position_label"
                    :label="this.$t('master.form.driver.driverStatus.currentPos')"
                    label-for="current_position"
                  >
                    <b-form-input
                      id="current_posotion"
                      :placeholder="$t('global.form.enter') + ' ' + $t('master.form.driver.driverStatus.currentPos')"
                      v-model="form.current_position"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="8" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="status_label"
                    :label="this.$t('master.form.driver.driverStatus.setStatus')"
                    label-for="status"
                  >
                    <v-select
                      v-model="form.status"
                      :placeholder="$t('master.form.driver.driverStatus.setStatus')"
                      :options="['Active', 'Inactive']"
                    ></v-select>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title">{{$t('master.form.driver.licenseType.text')}}</h4>
              </b-col>
              <b-col>
                <div class="float-end">
                  <b-button
                    v-if="selected.licence_type.length"
                    @click="toDelete('licence_type')"
                    variant="outline-danger"
                    class="mx-2"
                    size="sm"
                  >
                    <i class="bx bx-trash-alt"></i> {{$t("global.delete")}}
                  </b-button>
                  <b-button
                    variant="dark"
                    size="sm"
                    @click="
                      add('licence_type', {
                        type: null,
                        number: null,
                        expired: null,
                        status: null,
                      })
                    "
                  >
                    <i class="bx bx-plus"></i> {{$t("global.addField")}}
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :fields="licence_type"
              :items="tData.licence_type"
              class="mt-3"
              style="z-index: -1;"
            >
              <template #head(check)>
                <b-form-checkbox
                  @change="toggleAll($event, 'licence_type')"
                  v-model="allSelected.licence_type"
                  :indeterminate="indeterminate.licence_type"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </template>

              <template #cell(check)="data">
                <b-form-checkbox
                  @change="checkTable($event, data, 'licence_type')"
                  v-model="selectedModel.licence_type[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </template>

              <template #cell(type)="data">
                <v-select
                  class="style-chooser"
                  v-model="tData.licence_type[data.index].type"
                  placeholder="Select Document Type"
                  :options="['BPKB', 'KIR', 'SIUP', 'STNK']"
                ></v-select>
              </template>

              <template #cell(number)="data">
                <b-form-input
                 :placeholder="
										$t('master.form.fleet.documentPermit.form.number')
									"
                  v-model="tData.licence_type[data.index].number"
                  trim
                ></b-form-input>
              </template>

              <template #cell(expired)="data">
                <b-form-input
                  type="date"
                  placeholder="Expired"
                  v-model="tData.licence_type[data.index].expired"
                  trim
                  @change="checkStatus(data.index)"
                ></b-form-input>
              </template>

              <template #cell(status)="data">
                <div>
                  <b-badge
                    v-if="tData.licence_type[data.index].status === 'expired'"
                    class="bg-danger"
                    >{{
											$t("master.form.fleet.documentPermit.expired")
										}}</b-badge
                  >
                  <b-badge
                    v-else-if="tData.licence_type[data.index].status === 'near'"
                    class="bg-warning"
                    >{{
											$t(
												"master.form.fleet.documentPermit.status.nearExpired"
											)
										}}</b-badge
                  >
                  <b-badge
                    v-else-if="
                      tData.licence_type[data.index].status === 'active'
                    "
                    class="bg-success"
                    >{{
											$t("master.form.fleet.documentPermit.status.active")
										}}</b-badge
                  >
                </div>
              </template>
            </b-table>
          </b-card>

          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title">{{$t("master.form.driver.jobExp.text")}}</h4>
              </b-col>
              <b-col>
                <div class="float-end">
                  <b-button
                    v-if="selected.job_experience.length"
                    @click="toDelete('job_experience')"
                    variant="outline-danger"
                    class="mx-2"
                    size="sm"
                  >
                    <i class="bx bx-trash-alt"></i> {{$t("global.delete")}}
                  </b-button>
                  <b-button
                    variant="dark"
                    size="sm"
                    @click="add('job_experience', { job_experience: null })"
                  >
                    <i class="bx bx-plus"></i> {{$t("global.addField")}}
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :fields="job_experience"
              :items="tData.job_experience"
              class="mt-3"
            >
              <template #head(check)>
                <b-form-checkbox
                  v-model="allSelected.job_experience"
                  :indeterminate="indeterminate.job_experience"
                  @change="toggleAll($event, 'job_experience')"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </template>

              <template #cell(check)="data">
                <b-form-checkbox
                  @change="checkTable($event, data, 'job_experience')"
                  v-model="selectedModel.job_experience[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </template>

              <template #cell(job_experience)="data">
                <b-form-input
                  :placeholder="$t('master.form.driver.jobExp.text')"
                  v-model="tData.job_experience[data.index].job_experience"
                  trim
                ></b-form-input>
              </template>
            </b-table>
          </b-card>

          <b-card :title="$t('master.form.driver.violationHis.text')">
            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :fields="violation_history" 
              :items="tData.violation_history"
              class="mt-3"
            >
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </Layout>
</template>
